import { ReactNode } from "react";

export function PublicShell({ children }: { children: ReactNode }) {
    return (
        <main className="min-h-screen bg-muted/30">
            <div className="mx-auto flex min-h-screen w-full max-w-6xl flex-col px-4 py-6">
                {children}
            </div>
        </main>
    );
}